<!-- 范围列表 -->
<template>
   <div class='page_content'>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getDataList" :showRefresh="true" :buttonFlag="false"></v-button>
         <div class="page_content_top_line">
            <el-form :inline="true" :model="getRequestData" class="demo-form-inline" size="mini" label-width="100px">
               <el-form-item label="类型名称">
                  <label slot="label" :style="$common.labelStyle('类型名称')" v-html="$common.htmlLabel('类型名称')"></label>
                  <el-input class="form_codition" v-model.trim="getRequestData.surgeryName" clearable :maxlength="$store.state.inputLength"></el-input>
               </el-form-item>
               <el-form-item>
                  <el-button type="primary" size="mini" @click="searchData">查询</el-button>
               </el-form-item>
            </el-form>
         </div>
      </div>
      <div class="page_content_center">
         <el-table stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
            <el-table-column align="center" label="选择操作" width="80">
               <template slot-scope="scope">
                  <el-radio v-model="selectedDataIndex" :label="scope.row.index" border size="mini">
                     <i class="el-icon-thumb"></i>
                  </el-radio>
               </template>
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="surgeryName" label="类型名称"></el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="surgeryCode" label="助记码"></el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="remark" label="备注"></el-table-column>
            <el-table-column align="center" sortable show-overflow-tooltip prop="sort" label="排序"></el-table-column>
         </el-table>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <el-dialog :title="actionData.title" v-if="showStatus" :visible.sync="showStatus" width="500px">
         <el-form :model="sendDataInfo" ref="sendDataInfo" label-width="140px" class="demo-ruleForm" :inline-message="false" :show-message="false">
            <el-form-item label="手术类型名称" prop="surgeryName" :rules="[{ required: true,trigger: ['blur', 'change']}]">
               <el-input type="text" v-model="sendDataInfo.surgeryName" clearable></el-input>
            </el-form-item>
            <el-form-item label="助记码" prop="surgeryCode" :rules="[{ required: true,trigger: ['blur', 'change']}]">
               <el-input type="text" disabled v-model="sendDataInfo.surgeryCode" clearable></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
               <el-input type="number" v-model="sendDataInfo.sort" clearable></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
               <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="sendDataInfo.remark" clearable></el-input>
            </el-form-item>
         </el-form>
         <span slot="footer" class="dialog-footer">
            <el-button @click="showStatus = false">取 消</el-button>
            <el-button type="primary" @click="onSubmit('sendDataInfo')">保 存</el-button>
         </span>
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../byComponents/SearchScheme.vue";
import indexJS from './operationQuery';
export default {
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
   },
   data() {
      //这里存放数据
      return {
         tableHeight: 0,
         getRequestData: {
            surgeryName: "",
         },
         returnData: {
            list: [],
         },
         buttonList: indexJS.buttonList,
         selectedDataIndex: 0,
         seId: "",
         seTitle: "",
         seWidth: "",
         DialogVisible: false,
         seType: "",
         showStatus: false,
         actionData: {
            title: "",
            type: "",
         },
         sendDataInfo: {
            surgeryName: "",
            surgeryCode: "",
            sort: 0,
            remark: "",
         }
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.surgeryName": {
         handler: function (newValue, oldValue) {
            this.sendDataInfo.surgeryCode = this.$common.createPinyinCode(newValue, this.sendDataInfo.surgeryCode);
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      init() {
         this.sendDataInfo = {
            surgeryName: "",
            surgeryCode: "",
            sort: 0,
            remark: "",
         }
      },
      // 子组件触发
      drawerCancel() {
         this.showStatus = false;
         this.getDataList();
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type) {
         this.DialogVisible = true;
         this.seId = sId;
      },
      //返回数据
      changeInputModel(val) {
         console.log(val);

         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.getRequestData.scopeName = val.scopeName;
            this.getRequestData.opmId = val.opmId;
         }
      },
      getSeWidth(e) {
         console.log(e);
         this.seWidth = e + "%";
      },
      getSearchName(e) {
         console.log(e);
         this.seTitle = e;
      },

      // 动作集合
      actionSet(actionData) {
         switch (actionData.actionType) {
            case 0:
               this.init()
               this.showStatus = true;
               this.actionData = {
                  title: "新增",
                  type: 0,
               }
               break;
            case 1:
               var dataInfo = this.returnData.list[this.selectedDataIndex];
               if (!dataInfo) {
                  this.$message({
                     message: "请先选中要操作的数据",
                     type: "error",
                  });
                  return false;
               }
               this.sendDataInfo = {
                  surgeryName: dataInfo.surgeryName,
                  surgeryCode: dataInfo.surgeryCode,
                  sort: dataInfo.sort,
                  remark: dataInfo.remark,
               }
               this.showStatus = true;
               this.actionData = {
                  title: "修改",
                  type: 1,
               }
               break;
            case 2:
               this.delDataAction();
               break;
         }
      },
      onSubmit(formName) {
         this.$refs[formName].validate((valid) => {
            if (valid) {
               this.sub()
            } else {
               this.$message.error("请完善必填项！")
               return false;
            }
         });
      },
      async sub() {
         let responseData;
         let sendData = {}
         if (this.actionData.type === 0) {
            sendData = {
               sort: this.sendDataInfo.sort,
               surgeryCode: this.sendDataInfo.surgeryCode,
               surgeryName: this.sendDataInfo.surgeryName,
               remark: this.sendDataInfo.remark,
            }
            responseData = await this.$http.dictSurgeryadd(sendData)
         } else if (this.actionData.type === 1) {
            sendData = {
               sort: this.sendDataInfo.sort,
               surgeryCode: this.sendDataInfo.surgeryCode,
               surgeryName: this.sendDataInfo.surgeryName,
               remark: this.sendDataInfo.remark,
               id: this.returnData.list[this.selectedDataIndex].id,
            }
            responseData = await this.$http.dictSurgeryupdate(sendData)
         }
         if (responseData.status == 200) {
            this.showStatus = false
            this.getDataList()
            this.$message.success(responseData.message)
         } else {
            this.$message.error(responseData.message)
         }
      },
      // 删除数据
      delDataAction() {
         var dataInfo = this.returnData.list[this.selectedDataIndex];
         if (!dataInfo) {
            this.$message({
               message: "请先选中要操作的数据",
               type: "error",
            });
            return false;
         }

         this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         }).then(async () => {
            var delData = {
               ids: [dataInfo.id],
            };
            let responseData = await this.$http.dictSurgerydelete(delData);
            if (responseData.status == 200) {
               this.$message({
                  type: "success",
                  message: "删除成功!",
               });

               this.getDataList();
            } else {
               this.$message({
                  message: responseData.message,
                  type: "error",
               });
            }
         })
            .catch(() => { });
      },

      // 数据搜索
      searchData() {
         this.getRequestData.page = 1;
         this.getDataList();
      },

      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.dictSurgeryqueryList(
            this.getRequestData
         );
         if (responseData.status == 200) {
            this.returnData.list = this.$common.getIndex(responseData.result)
            this.selectedDataIndex = 0;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getDataList();
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_content_tag {
   margin-right: 1rem;
}

.el-tabs--border-card_new {
   height: 85vh;
   overflow-y: scroll;
}

.el-drawer {
   outline: none;
}
</style>
